import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BaseInterviewFormFieldComponent, BaseFormFieldServices } from '../base-interview-form-field/base-interview-form-field.component';
import { FieldDetailsComponent } from '@Components/field-details/field-details.component';
import {MaskitoDirective} from '@maskito/angular';
import {MaskitoOptions} from '@maskito/core';

@Component({
    selector: 'routing-number-answer',
    templateUrl: './routing-number-answer.component.html',
    styleUrls: ['./routing-number-answer.component.scss'],
    imports: [SharedModule, FieldDetailsComponent, MaskitoDirective]
})
export class RoutingNumberAnswerComponent extends BaseInterviewFormFieldComponent implements OnInit {
    maskitoOptions: MaskitoOptions = {
        mask:[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    };

    constructor(public services: BaseFormFieldServices) {

        super(services);
    }

    ngOnInit() {
        super.initialize({
            inputType: 'text',
            additionalValidators: [
                Validators.pattern(/^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$/)
            ]
        });
    }
}
